import assign from 'lodash/assign';
import ModalConstants from 'app/shared/constants/ModalConstants';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import merge from 'lodash/merge';

// default states passed as props to modal component from MUI
// expand the states when needed, supported props can be found here:
// https://bitbucket.hotterpads.com/projects/RP/repos/multibrand-ui/browse/src/Modal/Modal.js#12-61
const initState = () => ({
    modalType: '',
    isOpen: false,
    isWizard: false,
    hideBackButton: false,
    hideCloseButton: false,
    shouldCloseOnOverlayClick: true,
    parentSelector: ModalConstants.MODAL_PARENT_SELECTOR,
    className: '',
    header: '',
    onOpen: () => {},
    onClose: () => {},

    // TODO: refactor following to adapt to above pattern
    modalAddProperty: {
        // messages that are not empty will display errors in the UI
        error: {
            address: {
                message: '',
            },
            propertyType: {
                message: '',
            },
            numberOfUnits: {
                message: '',
            },
        },
        behavior: 'Add',
        isOpen: false,
    },
    modalEnableApplications: {
        isOpen: false,
    },
    modalImageCarousel: {
        isOpen: false,
    },
    modalVerifyEmail: {
        isOpen: false,
    },
    modalVerifyEmailFailure: {
        isOpen: false,
    },
});

const modal = (state = initState(), action = {}) => {
    const { type, payload } = action;

    let copyError = {};

    switch (type) {
        case DispatchConstants.MODAL_SHOW:
            return { ...state, ...payload, isOpen: true };
        case DispatchConstants.MODAL_UPDATE:
            return { ...state, ...payload };
        case DispatchConstants.MODAL_HIDE:
            return initState();

        // TODO: clean up
        case ModalConstants.MODAL_ADD_PROPERTY_UPDATE_DISPLAY: {
            const defaultErrorState = initState().modalAddProperty.error;

            // check if error in payload and use otherwise use default state
            copyError = (payload.error && Object.keys(payload.error).length > 0)
                ? merge({}, state.modalAddProperty.error, payload.error)
                : defaultErrorState;

            return assign({}, state, {
                ...state,
                modalAddProperty: {
                    ...state.modalAddProperty,
                    isOpen: payload.isOpen,
                    behavior: payload.behavior,
                    error: copyError,
                },
            });
        }
        case ModalConstants.MODAL_ENABLE_APPLICATIONS_UPDATE_DISPLAY:
            return assign({}, state, { modalEnableApplications: payload });

        case ModalConstants.MODAL_IMAGE_CAROUSEL_UPDATE_DISPLAY:
            return assign({}, state, { modalImageCarousel: payload });

        case ModalConstants.MODAL_VERIFY_EMAIL_UPDATE_DISPLAY:
            return assign({}, state, { modalVerifyEmail: payload });

        case ModalConstants.MODAL_VERIFY_EMAIL_FAILURE_UPDATE_DISPLAY:
            return assign({}, state, { modalVerifyEmailFailure: payload });

        default:
            return state;
    }
};

export default modal;
